// src/Components/AdminAdverts.js
import React from 'react';
import BroadcastPage from './Broadcast/BroadcastPage';

/**
 * @deprecated Используйте BroadcastPage вместо AdminAdverts
 * Этот компонент оставлен для обратной совместимости
 */
const AdminAdverts = (props) => {
  // Выводим предупреждение в консоль при разработке
  if (process.env.NODE_ENV === 'development') {
    console.warn(
      'AdminAdverts is deprecated and will be removed in future versions. ' +
      'Please update imports to use BroadcastPage from "./Broadcast"'
    );
  }
  
  return <BroadcastPage {...props} />;
};

export default AdminAdverts;